module.exports = __webpack_public_path__ + "static/media/gn.8cb5ad23.svg";